export default {
  data () {
    return {
      screenSize: {
        width: 0,
        height: 0
      },
      isPcSize: true
    }
  },
  created () {
    // localStorage.setItem('size_pc', true)
    // 绑定resize（判断pc/mob）
    // this.isPcSize = this.global.IsPC();
    this.screenSize.width = document.body.clientWidth
    this.screenSize.height = document.body.clientHeight
    if (document.body.clientWidth > 767) {
      this.isPcSize = true
      // localStorage.setItem('size_pc', true)
    } else {
      this.isPcSize = false
      // localStorage.setItem('size_pc', false)
    }
    // this.screenWidth = window.innerWidth
    // console.log(this.screenSize)
    window.addEventListener('resize', () => {
      this.screenSize.width = document.body.clientWidth
      this.screenSize.height = document.body.clientHeight
      if (document.body.clientWidth > 767) {
        this.isPcSize = true
        // localStorage.setItem('size_pc', true)
      } else {
        this.isPcSize = false
        // localStorage.setItem('size_pc', false)
      }
      // this.screenWidth = window.innerWidth
      // console.log(this.screenSize)
      this.$forceUpdate()
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixin/screen.js